//types
import {IFilterGroup} from '@/utils/types';

export type FilterRole = 'AllRoles' | 'Admins' | 'StandartUsers';
export type FilterActivity = ' AllUsers' | 'ActiveUsers' | ' InactiveUsers ' | 'InvitedUsers ';

export const options = [
	{id: '1', name: 'Member'},
	{id: '2', name: 'Admin'},
];

export const defaultFilterOptions: IFilterGroup[] = [
	{
		title: 'Role',
		options: [
			{title: 'All roles', isSelected: true, value: 'AllRoles'},
			{title: 'Admin', isSelected: false, value: 'Admins'},
			{title: 'Member', isSelected: false, value: 'StandartUsers'},
		],
	},
	{
		title: 'Activity',
		options: [
			{title: 'All users', isSelected: true, value: 'AllUsers'},
			{title: 'Active users', isSelected: false, value: 'ActiveUsers'},
			{title: 'Inactive users', isSelected: false, value: 'InactiveUsers'},
			{title: 'Invited users', isSelected: false, value: 'InvitedUsers'},
		],
	},
];

export const updateTeamFilterDataOptions = (
	roleSelected: string,
	activitySelected: string,
	filterData: IFilterGroup[]
): IFilterGroup[] => {
	return filterData.map((data) => {
		let newOptions = data.options;

		if (data.title === 'Role') {
			newOptions = data.options.map((option) => ({
				...option,
				isSelected: option.value === roleSelected,
			}));
		} else if (data.title === 'Activity') {
			newOptions = data.options.map((option) => ({
				...option,
				isSelected: option.value === activitySelected,
			}));
		}
		return {...data, options: newOptions};
	});
};

export function base64ToFile(base64: string, filename: string): File {
	const arr = base64.split(',');
	const mime = arr[0].match(/:(.*?);/)?.[1] || '';
	const bstr = atob(arr[1]);
	const n = bstr.length;
	const u8arr = new Uint8Array(n);

	for (let i = 0; i < n; i++) {
		u8arr[i] = bstr.charCodeAt(i);
	}

	return new File([u8arr], filename, {type: mime});
}
